import * as tslib_1 from "tslib";
import { UserViewModel } from 'src/app/models/users/user-view.model';
import { AppUserModel } from 'src/app/models/users/app-user.model';
import { RequestSettings } from 'src/app/models/requests/request-settings';
import { BaseService } from 'src/app/modules/core/services/base.service';
import { ServiceEndpoints } from 'src/app/models/endpoints/service-endpoints.model';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "./request.service";
import * as i2 from "./authentication.service";
export class UserService extends BaseService {
    constructor(request, authService) {
        super(request, new ServiceEndpoints({
            get: '',
            getAll: "user/query/users" /* GetAllUsers */,
            create: "user/command/create" /* CreateUser */,
            update: "user/command/update" /* UpdateUser */,
            delete: '',
        }), UserViewModel.makeList);
        this.request = request;
        this.authService = authService;
        this.onLoginSubject = new Subject();
    }
    getUsers() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.request.get("user/query/users" /* GetAllUsers */);
            return result.data;
        });
    }
    getById(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.request.getApi('user/' + id);
            return result.data;
        });
    }
    deleteUser(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.request.delete(`user/command/delete/${id}`);
            return result.data;
        });
    }
    updateUser(model) {
        return this.request.patch(this.endpoints.update, model, new RequestSettings({ isCustomErrorHandle: true }));
    }
    getCurrentUserAsync() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield this.request.get("user/me" /* GetCurrentUser */, new RequestSettings({ isCustomErrorHandle: true }));
            this.user = new AppUserModel(res);
            this.broadcastOnLogin();
            return this.user;
        });
    }
    getCurrentUserAsyncIgnore401() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                yield this.getCurrentUserAsync();
            }
            catch (e) {
                if (e.status === 401) {
                    this.removeUser();
                    this.authService.removeToken();
                    //swallow 401 errors
                    return;
                }
                throw e;
            }
        });
    }
    recoveryPassword(model) {
        return this.request.post("user/command/forgot-password-restore" /* RecoveryPassword */, model);
    }
    resetPassword(model) {
        return this.request.post("user/command/restore-password-by-code" /* ResetPassword */, model);
    }
    getCurrentUserSync() {
        return this.user;
    }
    removeUser() {
        this.user = undefined;
    }
    subscribeUserLogin(callback) {
        return this.onLoginSubject.subscribe(value => callback());
    }
    broadcastOnLogin() {
        this.onLoginSubject.next();
    }
}
UserService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(i0.ɵɵinject(i1.RequestService), i0.ɵɵinject(i2.AuthenticationService)); }, token: UserService, providedIn: "root" });
